import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  className?: string
}

function CheckboxUnmarked({ className }: Props) {
  return (
    <IconBase name="checkbox-unmarked" w={20} className={className}>
      <rect x="2" y="2" width="16" height="16" rx="1" stroke="currentColor" strokeWidth="2"/>
    </IconBase>
  )
}

export default CheckboxUnmarked
